import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Controller } from 'react-hook-form';

import Grid from '@material-ui/core/Grid';
import Card from '@material-ui/core/Card';
import { CardContent } from '@material-ui/core';
import IconButton from '@material-ui/core/IconButton';
import ListItem from '@material-ui/core/ListItem';
import List from '@material-ui/core/List';
import ListItemText from '@material-ui/core/ListItemText';
import CloseIcon from '@material-ui/icons/Close';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import { useTheme } from '@material-ui/core/styles';

export default function UploadFilesComponent({
  control,
  setValue,
  fileError,
  setFileError
}) {
  const { t } = useTranslation();
  const [draggingOver, setDraggingOver] = useState(false);
  const [fileList, setFileList] = useState([]);
  const theme = useTheme();

  const allowedFormats = ['application/pdf', 'image/jpeg', 'image/png'];

  const handleAddFiles = newFiles => {
    setFileError(null);
    const validFiles = newFiles.filter(file => allowedFormats.includes(file.type));
    const updatedFiles = [...fileList, ...validFiles];
    setFileList(updatedFiles);
    setValue('files', updatedFiles, { shouldValidate: true, shouldDirty: true });
  };

  const handleRemoveFile = fileToRemove => {
    setFileError(null);
    const updatedFiles = fileList.filter(file => file !== fileToRemove);
    setFileList(updatedFiles);
    setValue('files', updatedFiles, { shouldValidate: true, shouldDirty: true });
  };

  const handleDragOver = event => {
    setFileError(null);
    event.preventDefault();
    setDraggingOver(true);
  };

  const handleDragLeave = () => {
    setFileError(null);
    setDraggingOver(false);
  };

  const handleDrop = event => {
    setFileError(null);
    event.preventDefault();
    setDraggingOver(false);
    const droppedFiles = Array.from(event.dataTransfer.files || []);
    handleAddFiles(droppedFiles);
  };

  const handleInputChange = event => {
    setFileError(null);
    const selectedFiles = Array.from(event.target.files || []);
    handleAddFiles(selectedFiles);
    event.target.value = null;
  };

  return (
    <Grid item xs={12} md={12}>
      <Card
        onDragOver={handleDragOver}
        onDragLeave={handleDragLeave}
        onDrop={handleDrop}
        style={{
          backgroundColor: draggingOver ? theme.palette.primary.light : 'white'
        }}
      >
        <CardContent>
          <Controller
            name="files"
            control={control}
            defaultValue={[]}
            onChange={([event]) => {
              handleInputChange(event);
              return fileList;
            }}
            as={
              <>
                <input
                  id="inputId"
                  hidden
                  type="file"
                  accept=".pdf, .jpeg, .jpg, .png"
                  multiple
                  style={{ display: 'none' }}
                  onChange={handleInputChange}
                />
                <label
                  htmlFor="inputId"
                  style={{
                    padding: '12px 24px',
                    borderRadius: '8px',
                    cursor: 'pointer',
                    color: '#fff',
                    display: 'inline-block',
                    textAlign: 'center',
                    backgroundColor: theme.palette.primary.main,
                    transition: 'background-color 0.3s'
                  }}
                >
                  {t('attachChild_importFiles')}
                </label>
              </>
            }
          />

          <Grid item xs={12} md={12}>
            {fileList.length > 0 && (
              <List>
                {fileList.map(file => (
                  <ListItem key={file.name}>
                    <ListItemText primary={file.name} />
                    <ListItemSecondaryAction>
                      <IconButton
                        edge="end"
                        aria-label="delete"
                        onClick={() => handleRemoveFile(file)}
                      >
                        <CloseIcon />
                      </IconButton>
                    </ListItemSecondaryAction>
                  </ListItem>
                ))}
              </List>
            )}
          </Grid>
        </CardContent>
      </Card>
      <div style={{ color: 'red' }}>{fileError}</div>
    </Grid>
  );
}
